<div
  class="notification-dropdown-panel flex h-full w-full flex-col overflow-hidden rounded-2xl border border-border bg-card text-[13px] text-foreground shadow-[0_12px_40px_rgba(15,23,42,0.12)]"
>
  <!-- Header -->
  <div class="flex flex-shrink-0 items-center justify-between px-4 pb-2.5 pt-3.5">
    <div class="flex items-center gap-2">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="text-muted-foreground" aria-hidden="true">
        <path
          d="M19.0001 9.7041V9C19.0001 5.13401 15.8661 2 12.0001 2C8.13407 2 5.00006 5.13401 5.00006 9V9.7041C5.00006 10.5491 4.74995 11.3752 4.28123 12.0783L3.13263 13.8012C2.08349 15.3749 2.88442 17.5139 4.70913 18.0116C9.48258 19.3134 14.5175 19.3134 19.291 18.0116C21.1157 17.5139 21.9166 15.3749 20.8675 13.8012L19.7189 12.0783C19.2502 11.3752 19.0001 10.5491 19.0001 9.7041Z"
          stroke="currentColor"
          stroke-width="1.5"
        />
        <path d="M7.5 19C8.15503 20.7478 9.92246 22 12 22C14.0775 22 15.845 20.7478 16.5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      </svg>
      <h4 id="notification-panel-title" class="text-sm font-semibold leading-none text-foreground">Notifications</h4>
    </div>
    <button
      type="button"
      class="grid h-7 w-7 place-content-center rounded-full text-muted-foreground transition hover:bg-muted hover:text-foreground"
      aria-label="Close notifications"
      (click)="closePanel($event)"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      </svg>
    </button>
  </div>

  <!-- Tabs + actions -->
  <div class="flex flex-shrink-0 items-start justify-between gap-2 px-4 pb-2.5">
    <div class="flex flex-wrap items-center gap-1.5">
      @for (tab of tabs; track tab.id) {
        <button
          type="button"
          class="rounded-full px-3 py-1 text-xs font-medium transition"
          [class.bg-[#111827]]="activeTab() === tab.id"
          [class.text-white]="activeTab() === tab.id"
          [class.dark:bg-white]="activeTab() === tab.id"
          [class.dark:text-[#111827]]="activeTab() === tab.id"
          [class.border]="activeTab() !== tab.id"
          [class.border-[#e5e7eb]]="activeTab() !== tab.id"
          [class.bg-white]="activeTab() !== tab.id"
          [class.text-[#4b5563]]="activeTab() !== tab.id"
          [class.dark:border-white/15]="activeTab() !== tab.id"
          [class.dark:bg-transparent]="activeTab() !== tab.id"
          [class.dark:text-white-light]="activeTab() !== tab.id"
          (click)="setTab(tab.id); $event.stopPropagation()"
        >
          {{ tab.label }}
        </button>
      }
    </div>
    <div class="flex shrink-0 items-center gap-1.5">
      <button
        type="button"
        class="grid h-8 w-8 place-content-center rounded-lg border border-[#e5e7eb] text-[#6b7280] transition hover:bg-[#f9fafb] hover:text-[#111827] dark:border-white/15 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white-light"
        aria-label="Filter notifications"
        (click)="openNotificationCenter($event)"
      >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.66708 13.3333C6.66702 13.4572 6.70148 13.5787 6.7666 13.6841C6.83172 13.7895 6.92492 13.8746 7.03574 13.93L8.36908 14.5967C8.47074 14.6475 8.58371 14.6714 8.69724 14.6663C8.81077 14.6612 8.92111 14.6271 9.01776 14.5673C9.11442 14.5075 9.19419 14.424 9.24949 14.3247C9.30479 14.2254 9.3338 14.1137 9.33374 14V9.33333C9.33389 9.00292 9.45672 8.68433 9.67841 8.43933L14.4937 3.11333C14.5801 3.01771 14.6368 2.89912 14.6571 2.77192C14.6775 2.64472 14.6605 2.51435 14.6083 2.39658C14.5562 2.27881 14.471 2.17868 14.3631 2.1083C14.2552 2.03792 14.1292 2.0003 14.0004 2H2.00041C1.87148 2.00005 1.74533 2.03748 1.63724 2.10776C1.52915 2.17804 1.44376 2.27815 1.39141 2.39598C1.33906 2.5138 1.322 2.64427 1.34229 2.77159C1.36259 2.89892 1.41936 3.01762 1.50574 3.11333L6.32241 8.43933C6.5441 8.68433 6.66693 9.00292 6.66708 9.33333V13.3333Z" stroke="#0A0A0A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>        
      </button>
      <button
        type="button"
        class="grid h-8 w-8 place-content-center rounded-lg border border-[#e5e7eb] text-[#6b7280] transition hover:bg-[#f9fafb] hover:text-[#111827] dark:border-white/15 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white-light"
        aria-label="Notification settings"
        (click)="openNotificationCenter($event)"
      >
      <svg width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_43814_61759)">
        <path d="M13.7496 22H8.24957V18.7798C7.29372 18.4416 6.4084 17.9301 5.63799 17.2709L2.84766 18.8833L0.0976562 14.1167L2.88707 12.5079C2.70384 11.511 2.70384 10.489 2.88707 9.49208L0.0976562 7.88333L2.84766 3.11667L5.63799 4.72908C6.4084 4.06993 7.29372 3.55844 8.24957 3.22025V0H13.7496V3.22025C14.7054 3.55844 15.5907 4.06993 16.3612 4.72908L19.1515 3.11667L21.9015 7.88333L19.1121 9.49208C19.2953 10.489 19.2953 11.511 19.1121 12.5079L21.9015 14.1167L19.1515 18.8833L16.3612 17.2718C15.5907 17.9307 14.7054 18.4418 13.7496 18.7798V22ZM10.0829 20.1667H11.9162V17.3919L12.6047 17.2141C13.734 16.9215 14.7619 16.3259 15.5774 15.4917L16.0752 14.9848L18.4796 16.3735L19.3962 14.7858L16.9946 13.3989L17.1834 12.7151C17.4938 11.5903 17.4938 10.4024 17.1834 9.27758L16.9946 8.59375L19.3962 7.20683L18.4796 5.61917L16.0752 7.01158L15.5774 6.50833C14.7615 5.6754 13.7336 5.0811 12.6047 4.78958L11.9162 4.60808V1.83333H10.0829V4.60808L9.39449 4.78592C8.26515 5.07847 7.23721 5.67406 6.42174 6.50833L5.92399 7.01525L3.51957 5.62283L2.60291 7.2105L5.00457 8.59742L4.81574 9.28125C4.50532 10.4061 4.50532 11.5939 4.81574 12.7188L5.00457 13.4026L2.60291 14.7895L3.51957 16.3772L5.92399 14.9884L6.42174 15.4953C7.23765 16.3283 8.26555 16.9226 9.39449 17.2141L10.0829 17.3919V20.1667ZM10.9996 14.6667C10.2744 14.6667 9.56546 14.4516 8.96248 14.0487C8.3595 13.6458 7.88954 13.0732 7.61201 12.4032C7.33449 11.7332 7.26188 10.9959 7.40336 10.2847C7.54484 9.57341 7.89406 8.92007 8.40685 8.40728C8.91964 7.89448 9.57298 7.54527 10.2842 7.40379C10.9955 7.26231 11.7327 7.33492 12.4027 7.61244C13.0727 7.88996 13.6454 8.35993 14.0483 8.96291C14.4512 9.56589 14.6662 10.2748 14.6662 11C14.6662 11.9725 14.2799 12.9051 13.5923 13.5927C12.9047 14.2804 11.972 14.6667 10.9996 14.6667ZM10.9996 9.16667C10.637 9.16667 10.2825 9.27419 9.98103 9.47564C9.67954 9.67709 9.44455 9.96342 9.30579 10.2984C9.16703 10.6334 9.13073 11.002 9.20147 11.3577C9.27221 11.7133 9.44681 12.04 9.70321 12.2964C9.95961 12.5528 10.2863 12.7274 10.6419 12.7981C10.9975 12.8688 11.3662 12.8325 11.7012 12.6938C12.0362 12.555 12.3225 12.32 12.5239 12.0185C12.7254 11.7171 12.8329 11.3626 12.8329 11C12.8329 10.5138 12.6398 10.0475 12.2959 9.70364C11.9521 9.35982 11.4858 9.16667 10.9996 9.16667Z" fill="black"/>
        </g>
        <defs>
        <clipPath id="clip0_43814_61759">
        <rect width="22" height="22" fill="white"/>
        </clipPath>
        </defs>
        </svg>        
      </button>
    </div>
  </div>

  <!-- List -->
  <div class="min-h-0 flex-1 overflow-y-auto overflow-x-hidden border-t border-[#e5e7eb] dark:border-white/10">
    @if (listLoading()) {
      <div class="grid min-h-[200px] place-content-center px-4 py-8 text-center text-xs text-[#6b7280]">
        Loading…
      </div>
    } @else if (listItems().length) {
      @for (notification of listItems(); track trackById($index, notification)) {
        <article class="relative border-b border-[#e5e7eb] px-4 py-3 last:border-b-0 dark:border-white/10">
          <div class="flex gap-2.5">
            <div class="grid h-7 w-7 shrink-0 place-content-center rounded-full bg-[#f3f4f6] text-[#111827] dark:bg-white/10 dark:text-gray-400">
              @switch (notificationIconKind(notification)) {
                @case ('deal') {
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                    <path d="M14 2V8H20" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                    <path d="M8 13H16M8 17H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                  </svg>
                }
                @case ('lead') {
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                    <path d="M14 2V8H20" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                  </svg>
                }
                @case ('announce') {
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M3 11V13H7L12 18V6L7 11H3Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                    <path d="M16 8C17.5 9.5 18 11.2 18 12C18 12.8 17.5 14.5 16 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                  </svg>
                }
                @case ('calendar') {
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M8 2V5M16 2V5M3 9H21M5 5H19C20.1 5 21 5.9 21 7V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V7C3 5.9 3.9 5 5 5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    <path d="M8 13H12V17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                }
                @case ('web') {
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5" />
                    <path d="M3 12H21M12 3C14.5 6.5 15.8 9.2 16 12C15.8 14.8 14.5 17.5 12 21C9.5 17.5 8.2 14.8 8 12C8.2 9.2 9.5 6.5 12 3Z" stroke="currentColor" stroke-width="1.5" />
                  </svg>
                }
                @case ('company') {
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M4 21H20M6 21V8L12 4L18 8V21" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                    <path d="M10 12H14M10 16H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                  </svg>
                }
                @case ('task') {
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M8 2V5M16 2V5M3 9H21M5 5H19C20.1 5 21 5.9 21 7V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V7C3 5.9 3.9 5 5 5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                  </svg>
                }
                @default {
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                    <path d="M14 2V8H20" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                  </svg>
                }
              }
            </div>

            <div
              class="min-w-0 flex-1"
              [class.pr-7]="activeTab() !== 'trash' && notification.isRead"
              [class.pr-[42px]]="activeTab() !== 'trash' && !notification.isRead"
            >
              <h6 class="text-[13px] font-semibold leading-tight text-[#111827] dark:text-white-light">
                {{ notification.title }}
              </h6>

              @if (messagePreview(notification)) {
                <p class="mt-0.5 text-xs leading-snug text-[#6b7280] dark:text-gray-400">
                  {{ messagePreview(notification) }}
                </p>
              }

              @if (notification.time) {
                <p class="mt-1 flex items-center gap-1 text-[10px] text-[#9ca3af]">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5" />
                    <path d="M12 7V12L15 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                  </svg>
                  {{ notification.time }}
                </p>
              }
            </div>
          </div>

          @if (activeTab() !== 'trash') {
            <div class="absolute top-1 flex items-center gap-1 ltr:right-2 rtl:left-2">
              @if (showMarkReadAction(notification)) {
                <button
                  type="button"
                  class="inline-flex h-6 w-6 shrink-0 items-center justify-center text-[#111827] transition hover:text-[#111827] dark:hover:text-white-light"
                  aria-label="Mark as read"
                  (click)="onMarkRead(notification.id, $event)"
                >
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_43771_61326)">
                  <path d="M5.00912 9.37948L1.60328 5.86615L3.39828 4.12615L6.49245 7.31865L13.3666 0.445312L15.1341 2.21281L7.96162 9.38531C7.56828 9.77865 7.04162 9.99531 6.48495 9.99531C5.92661 9.99448 5.40245 9.77531 5.00912 9.37948ZM17.8316 5.14615L6.48911 16.4886L2.13828 12.1003L0.363281 13.8611L5.00828 18.5445C5.40161 18.9411 5.92495 19.1595 6.48328 19.1611C7.03911 19.1611 7.56745 18.9445 7.96078 18.5511L19.5991 6.91281L17.8316 5.14615Z" fill="black"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_43771_61326">
                  <rect width="20" height="20" fill="white"/>
                  </clipPath>
                  </defs>
                  </svg>
                  
                </button>
              }
              <button
                type="button"
                class="inline-flex h-8 w-8 shrink-0 items-center justify-center text-[#111827] transition dark:hover:text-white-light"
                aria-label="Move to trash"
                (click)="onMoveToTrash(notification.id, $event)"
              >
                <icon-trash-lines class="h-4.5 w-4.5" />
              </button>
            </div>
          }
        </article>
      }
    } @else {
      <div class="grid min-h-[200px] place-content-center px-4 py-8 text-center text-xs text-[#6b7280]">
        @if (activeTab() === 'trash') {
          Trash is empty
        } @else if (activeTab() === 'unread') {
          No unread notifications
        } @else {
          No notifications yet
        }
      </div>
    }
  </div>

  <!-- Footer -->
  <div class="grid flex-shrink-0 grid-cols-2 gap-2 border-t border-[#e5e7eb] px-4 py-3 dark:border-white/10">
    <button
      type="button"
      class="w-full rounded-full border border-[#e5e7eb] bg-white px-2.5 py-2 text-[11px] font-medium text-[#4b5563] transition hover:bg-[#f9fafb] disabled:cursor-not-allowed disabled:opacity-50 dark:border-white/15 dark:bg-transparent dark:text-white-light"
      [disabled]="notificationService.unreadCount() === 0"
      (click)="onMarkAllRead($event)"
    >
      Mark all as Read
    </button>
    <button
      type="button"
      class="w-full rounded-full bg-[#111827] px-2.5 py-2 text-[11px] font-medium text-white transition hover:bg-black/90 dark:bg-white dark:text-[#111827]"
      (click)="openNotificationCenter($event)"
    >
      Open Notification Center
    </button>
  </div>
</div>
